<template>
  <el-dialog
    :title="title"
    append-to-body
    :visible.sync="visible"
    width="60%"
    :before-close="handleClose"
    top="15vh"
    v-if="visible"
  >
    <avue-crud
      ref="avueCrud"
      :option="option"
      v-model="form"
      :data="tableData"
      :table-loading="TABLE_LOADING"
      :page.sync="TABLE_PAGE"
      @search-change="SEARCH_CHANGE"
      @refresh-change="TABLE_REFRESH"
      @search-reset="SEARCH_RESET"
      @cell-click="CELL_CLICK"
      @selection-change="SELECTION_CHANGE"
      @sort-change="SORT_CHANGE"
      @size-change="SIZE_CHANGE"
      @current-change="CURRENT_CHANGE"
      :before-open="beforeOpen"
      :before-close="beforeClose"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
    >
    </avue-crud>
     <div class="operate">
        <el-row>
          <el-button type="primary" @click="handleConfirm">确定</el-button>
          <el-button type="info" plain @click="handleClose">取消</el-button>
        </el-row>
      </div>
  </el-dialog>
</template>
<script>
import { getDictionary } from '@/businessManagement/utils/jwTools.js'
import crudPageMinix from '@/businessManagement/utils/crudPageMinix.js'
export default {
  mixins: [crudPageMinix],
  props: {
    visible: {
      type: Boolean, // sync
      default: false
    },
    title: {
      type: String,
      default: '选择交付项目'
    }
  },
  data() {
    return {
      TABLE_LOADING: false,
      option: {
        selection: true,
        border: true,
        dialogDrag: true,
        dialogClickModal: false,
        searchMenuSpan: 6,
        index: true,
        indexLabel: '序号',
        labelWidth: 120,
        align: 'center',
        tip: false,
        stripe: true,
        addBtn: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        menu: false,
        column: [
          {
            label: '项目名称',
            prop: 'xm_mc',
            search: true,
            overHidden: true,
            searchLabelWidth: 80,
            minWidth: 120
          },
          {
            label: '客户名称',
            prop: 'kh_mc',
            search: true,
            overHidden: true,
            searchLabelWidth: 80,
            minWidth: 120
          },
          {
            label: '项目经理',
            prop: 'xm_fzr',
            search: true,
            overHidden: true,
            searchLabelWidth: 80,
            minWidth: 80
          },
          {
            label: '项目总监',
            prop: 'xmzj',
            search: true,
            overHidden: true,
            searchLabelWidth: 80,
            minWidth: 80
          },
          {
            label: '项目等级',
            prop: 'xmdj',
            overHidden: true,
            slot: true,
            search: true,
            type: 'select',
            searchLabelWidth: 80,
            minWidth: 80,
            dicData: [
              {
                label: 'A级',
                value: 'A'
              },
              {
                label: 'B级',
                value: 'B'
              },
              {
                label: 'C级',
                value: 'C'
              }
            ]
          },
          {
            label: '计划验收日期',
            prop: 'jhysrq',
            minWidth: 100,
            overHidden: true,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            rules: [
              {
                required: true,
                message: '请输入开始时间',
                trigger: 'blur'
              }
            ]
          },
          {
            label: '项目状态',
            prop: 'xmjfzt',
            search: true,
            overHidden: true,
            searchLabelWidth: 80,
            minWidth: 80,
            type: 'select'
          },
          {
            label: '交付里程碑',
            prop: 'lcb',
            search: true,
            overHidden: true,
            searchLabelWidth: 90,
            minWidth: 90,
            type: 'select'
          },
          {
            label: '验收状态',
            prop: 'yszk',
            search: true,
            overHidden: true,
            searchLabelWidth: 80,
            minWidth: 80,
            type: 'select'
          },
          {
            label: '更新时间',
            prop: 'gxsj',
            overHidden: true,
            minWidth: 100
          }
        ]
      },
      form: {},
      tableData: []
    }
  },
  mounted() {
    this.loadData()

    getDictionary('LCB').then((dic) => {
      this.$set(
        this.option.column[
          this.findArray(this.option.column, 'lcb', 'prop')
        ],
        'dicData',
        dic
      )
    })
    getDictionary('XMJFZT').then((dic) => {
      this.$set(
        this.option.column[
          this.findArray(this.option.column, 'xmjfzt', 'prop')
        ],
        'dicData',
        dic
      )
    })
    getDictionary('YSZK').then((dic) => {
      this.$set(
        this.option.column[
          this.findArray(this.option.column, 'yszk', 'prop')
        ],
        'dicData',
        dic
      )
    })
    getDictionary('FROMID').then((dic) => {
      dic.map(item => {
        if (item.value == '交付项目') {
          this.formid = item.label
        }
      })
    })
  },
  methods: {
    // 加载表格数据
    loadData(TABLE_PAGE = this.TABLE_PAGE, QUERY_CONDITIONS = this.QUERY_CONDITIONS, TABLE_ORDER = this.TABLE_ORDER, done) {
      this.TABLE_LOADING = true // 表格转圈
      this.SELECT_LIST = [] // 清空选中行
      var formData = new window.FormData()
      formData.append('pageNum', TABLE_PAGE.currentPage)
      formData.append('pageSize', TABLE_PAGE.pageSize)
      formData.append('yjrwid', '1')
      formData.append('khmc', this.form.kh_mc || '')
      this.$http.post('/fighter-workflow-saas/RwManage/listTkxxByYjrwId', formData).then(response => {
        this.RELOAD_CRUD(response.data.records)
        this.TABLE_PAGE.total = response.data.total || response.data.records.length
        this.SELECT_LIST = []
      }).catch(error => {
        this.$message.error(error.msg || error.message)
      }).finally(() => {
        this.TABLE_LOADING = false // 表格转圈
        typeof done === 'function' && done()
      })
    },
    handleConfirm() {
      console.log(this.SELECT_LIST)
      this.$emit('onChecked', [
        ...this.SELECT_LIST
      ])
      this.handleClose()
    },
    handleClose(done) {
      this.$emit('update:visible', false)
    }
  }
}
</script>
